import dayjs from "dayjs";

export function generateSlides(jsonData, noAla = false) {
   // Return an empty array if jsonData is null
   if (!jsonData) {
      return [];
   }

   // Parse the JSON
   const parsedData = Array.isArray(jsonData) ? jsonData : JSON.parse(jsonData);

   // Map over the menus to create the desired structure
   const slides = parsedData.map(menu => {
      // Extract the documentId
      const id = menu.documentId;

      // Extract the title (entry starting with '=')
      const titleEntry = menu.menutext.find(
         entry => entry.children[0].text.startsWith("=")
      );
      const title = titleEntry ? titleEntry.children[0].text.replace(/^=+/, "").trim() : null;

      const specialoffer = menu.specialoffer;
      const vegetarian = menu.vegetarian;
      const price = menu.price;

      // Process the courses
      const courses = [];
      let currentCourse = null;

      menu.menutext.forEach(entry => {
         const text = entry.children[0].text;

         if (text.startsWith("===")) {
            // Add subtitle if "===" is found
            if (currentCourse) {
               currentCourse.coursesubtitle = text.replace(/^=+/, "").trim();
            }
         } else if (text.startsWith("==")) {
            // Start a new course if "==" is found
            if (currentCourse) {
               courses.push(currentCourse);
            }
            currentCourse = { coursetitle: text.replace(/^=+/, "").trim(), coursesubtitle: null, coursedesc: null };
         } else if (!text.startsWith("=")) {
            // Add description to the current course if no "="
            if (currentCourse) {
               currentCourse.coursedesc = text;
            }
         }
      });

      // Push the last course if it exists
      if (currentCourse) {
         courses.push(currentCourse);
      }

      return {
         id,
         title,
         courses,
         specialoffer,
         vegetarian,
         price,
         adults: 0,
         children: 0
      };
   });

   // Sort the slides: special offers first, then vegetarian, then others
   slides.sort((a, b) => {
      if (a.specialoffer && !b.specialoffer) {
         return -1;
      } else if (!a.specialoffer && b.specialoffer) {
         return 1;
      } else if (a.vegetarian && !b.vegetarian) {
         return -1;
      } else if (!a.vegetarian && b.vegetarian) {
         return 1;
      } else {
         return 0;
      }
   });

   if (noAla == false) {
      slides.push(
         {
            id: "alacarte",
            title: "À-la-carte",
            courses: [
               {
                  coursetitle: null,
                  coursesubtitle: "Du entscheidest vor Ort, was Du essen möchten.",
                  coursedesc: "Erlebe kulinarische Highlights und entdecke besondere Gaumenfreuden mit unserer vielfältigen À-la-carte-Auswahl. Wenn du vorab einen Blick in die Karte werfen möchtest, kannst Du das in der Menüleiste unter 'Speisekarte'."
               }
            ],
            adults: 0,
            children: 0
         })
   }
   return slides;
}

export const allowMenuChoose = (date) => {
   const now = dayjs();
   const selectedDate = dayjs(date);

   // Disallow menu chooser same day after 12:00
   if (selectedDate.isSame(now, "day") && now.hour() >= 12) return false;

   return true;
};

export const isDisabledDate = (date) => {
   const now = dayjs();
   const selectedDate = dayjs(date);

   // Disallow past dates
   if (selectedDate.isBefore(now, "day")) return true;

   // Disallow same day after 17:00
   if (selectedDate.isSame(now, "day") && now.hour() >= 17) return true;

   // Disallow dates more than 7 days in the future
   if (selectedDate.isAfter(now.add(7, "day"), "day")) return true;

   return false;
};

export const isDisabledTime = (timeValue, clockType) => {
   const time = dayjs(timeValue);

   // Only allow times between 17:45 and 20:00
   if (clockType === "hours") {
      const hour = time.hour();
      return hour < 17 || hour > 20;
   }

   if (clockType === "minutes") {
      const hour = time.hour();
      const minutes = time.minute();

      // Disallow times before 17:45 or after 20:00
      if (hour === 17 && minutes < 45) return true;
      if (hour === 20 && minutes > 0) return true;

      // Disallow minutes not in 15-minute intervals
      return minutes % 15 !== 0;
   }

   return false;
};

export function isAllowedTime(timeValue) {
   const time = dayjs(timeValue);
   if (time.hour() == 17 && time.minute() != 45) { return false; }
   if (time.hour() == 20 && time.minute() != 0) { return false; }
   if (time.hour() >= 17 && time.hour() <= 20) { return true; }
   return false;
}

export function roundToNearestTenCents(value) {
   return (Math.round(value * 10) / 10).toFixed(2); // Multiplizieren, runden, zurückskalieren
}

export const updateSelectedDateTime = (date, time) => {
   if (date && time) {
      return dayjs(date).hour(dayjs(time).hour()).minute(dayjs(time).minute());
   }
   return null;
};  